export const qualifStatus = {
  Checking: {
    value: 1,
    name: '审核中',
    icon: 'el-icon-time color-brand'
  },
  Ok: {
    value: 2,
    name: '审核通过',
    icon: 'el-icon-circle-check color-success'
  },
  NotUpload: {
    value: 3,
    name: '未上传',
    icon: 'el-icon-warning-outline color-warning'
  },
  Fail: {
    value: 4,
    name: '审核未通过',
    icon: 'el-icon-circle-close color-error'
  }
};

export const RechargeColumns = [
  {name: '充值成功时间', key: 'successTimeFormat'},
  {name: '充值申请时间', key: 'applyTimeFormat'},
  {name: '付款公司', key: 'paymentCompanyName'},
  {name: '充值金额（元）', key: 'amount'}
];

export const DeductColumns = [
  {name: '退款成功时间', key: 'successTimeFormat'},
  {name: '退款申请时间', key: 'applyTimeFormat'},
  {name: '收款公司', key: 'accountName'},
  {name: '退款金额（元）', key: 'amount'}
];

export const InvoiceColor = {
  BLUE: 0, // 蓝票
  RED: 1 // 红票
};

export const InvoiceType = {
  NORMAL: 0, // 增值税普通发票
  SPECIAL: 1, // 增值税专用发票
  DIGITAL_NORMAL: 2, // 数电发票（普通发票）
  DIGITAL_SPECIAL: 3 // 数电发票（增值税专用发票）
};


export const InvoiceMode = {
  NORMAL: 1, // 正常开票
  PRE: 2 // 预开票
};

export const RedApplyReason = {
  HAS_DEDUCT: 0, // 有退款申请红字发票开票
  HAS_REBEATE: 1, // 有返点申请红字发票开票
  BLUE_CANCEL: 2, // 蓝票作废跨月红冲
}